import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import useReveal from "@/hooks/useReveal";
import { useCurrency } from "@/context/CurrencyContext";
import { Check, MapPin } from "@phosphor-icons/react";

export default function Cloud() {
  const ref = useReveal();
  const { format } = useCurrency();
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/hosting-plans").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <section id="cloud" ref={ref} data-testid="cloud" className="reveal section border-b border-[color:var(--line)]">
      <div className="container-x">
        <div className="flex items-end justify-between gap-6 flex-wrap mb-12">
          <div>
            <div className="eyebrow">Cloud & Hosting</div>
            <h2 className="font-display font-black text-4xl md:text-5xl mt-4 leading-[1.02] max-w-2xl">
              Managed cloud with the region on your terms.
            </h2>
          </div>
          <p className="max-w-md text-neutral-600">
            Pick UAE, EU or India based on where your data must live. All plans include monitoring, backups and 24/7 response.
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {items.map((p) => (
            <div
              key={p.id}
              data-testid={`cloud-${p.region.toLowerCase()}`}
              className={`card-line p-8 flex flex-col ${p.highlight ? "border-[color:var(--ink)]" : ""}`}
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-xs uppercase tracking-widest text-neutral-500 flex items-center gap-1">
                  <MapPin size={12} weight="bold" /> {p.region}
                </span>
                {p.highlight && <span className="font-mono text-[10px] uppercase tracking-widest bg-[color:var(--brand)] text-white px-2 py-1">Popular</span>}
              </div>
              <h3 className="font-display font-bold text-2xl mt-4">{p.name}</h3>
              <p className="text-neutral-600 mt-1">{p.tagline}</p>
              <div className="mt-6 flex items-baseline gap-2">
                <span className="font-display font-black text-4xl">{format(p.price_inr_monthly)}</span>
                <span className="font-mono text-xs uppercase tracking-widest text-neutral-500">/ month</span>
              </div>
              <ul className="mt-6 space-y-3 flex-1">
                {p.features.map((f) => (
                  <li key={f} className="text-sm text-neutral-700 flex gap-2 items-start">
                    <Check size={16} weight="bold" className="text-[color:var(--brand)] mt-1" /> {f}
                  </li>
                ))}
              </ul>
              <a
                href="#contact"
                data-testid={`cloud-cta-${p.region.toLowerCase()}`}
                className="mt-8 btn-ghost text-sm py-3 justify-center"
              >Choose {p.region}</a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
